import React, { FC } from 'react'

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import styled from 'styled-components'

import { CircleIconButton } from '@style-port/roov-ui-components-react'
import { Icon, Txt } from 'src/components/atoms'

dayjs.extend(isSameOrAfter)

const MonthTxt = styled(Txt)`
  font-size: var(--s3);
`

type Props = {
  targetDate: Date
  onClickPrev: () => void
  onClickNext: () => void
  disabledAfterDate?: Date
  className?: string
}

export const CalendarHeader: FC<Props> = ({
  targetDate,
  onClickPrev,
  disabledAfterDate,
  onClickNext,
  className,
}) => {
  const disabledNextMonth =
    !!disabledAfterDate &&
    dayjs(targetDate).isSameOrAfter(dayjs(disabledAfterDate).startOf('month'))

  return (
    <div className={className}>
      <div className="tw-flex tw-justify-between tw-items-start">
        <CircleIconButton buttonType="standard-primary" onClick={onClickPrev}>
          <Icon path="arrow-left/soft/line" />
        </CircleIconButton>
        <div className="tw-flex tw-bold tw-items-center tw-text-standardText-secondary">
          <Txt fontType="alphabet">{targetDate.getFullYear()}</Txt>
          <MonthTxt fontType="alphabet" className="tw-ml-s-2">
            {targetDate.getMonth() + 1}
          </MonthTxt>
        </div>
        <CircleIconButton
          buttonType="standard-primary"
          onClick={() => !disabledNextMonth && onClickNext()}
          disabled={disabledNextMonth}
        >
          <Icon path="arrow-right/soft/line" />
        </CircleIconButton>
      </div>
    </div>
  )
}
